import GameUtil from "../../../../utility/game_util";

const {ccclass, property} = cc._decorator;

@ccclass
export default class FirstChargeItem extends cc.Component {

    @property(cc.Label)
    disCountLab:cc.Label = null;

    @property(cc.Node)
    maskDisCountSp:cc.Node = null;

    @property(cc.Node)
    alreadyAward:cc.Node = null;

    @property(cc.Label)
    goldNumb:cc.Label = null;

    @property(cc.Node)
    haveDuiGou:cc.Node=null;

    //当前可购买的亮 其余灰 已购买的加沟
    initItem(award:any,curProgress:number){
        let conditionGroup= award.activityConditionGroup;
        let isSell = conditionGroup < curProgress;
        this.updateGoldNumb(award);
        this.showSellItem(isSell,conditionGroup == curProgress);
    }

    //isCanSell:可出售的
    showSellItem(isSell:boolean,isCanSell:boolean){
        this.alreadyAward.active = !isCanSell ;
        this.maskDisCountSp.active = !isCanSell;
        this.haveDuiGou.active = isSell;
    }

    updateGoldNumb(award:any){

        let goods = award.goodsVo
        let numb1 = GameUtil.currencyFormatting(goods.num,0,true)
        let giftNumb = 0
        for (let i = 0; i < goods.giftList.length; i++) {
            let item = goods.giftList[i];
            giftNumb += item.num;
        }
        let numb2 = GameUtil.currencyFormatting(giftNumb,0,true);
        this.goldNumb.string = '{0} + {1}'.format(numb1,numb2);
        let disCount = 0
        if (goods.num == 0) {
            disCount = 0
        }else{
            disCount = (giftNumb / goods.num) * 100;
            disCount = parseInt(disCount.toString(),0); 
        }
        this.disCountLab.string = 'ฟรี' + disCount + '%';
    }
}
